import { Heading, VStack } from "@chakra-ui/layout";
import React from "react";
import { useLayoutContext } from "../../context/LayoutContext";

interface PageHeadingProps {
  children?: React.ReactNode;
}

const envTitlePrefix =
  APP_ENVIRONMENT !== "" && APP_ENVIRONMENT !== "production"
    ? APP_ENVIRONMENT.charAt(0).toUpperCase() +
      APP_ENVIRONMENT.slice(1).toLowerCase()
    : null;

const Title = ({ children }: { children: React.ReactNode }) => {
  return (
    <Heading
      as="h1"
      width="100%"
      color="white"
      fontWeight="600"
      mt="auto"
      mb="auto"
    >
      {envTitlePrefix ? (
        <>
          {envTitlePrefix} {children}
        </>
      ) : (
        children
      )}
    </Heading>
  );
};

export const PageHeading = ({ children }: PageHeadingProps) => {
  const { isDesktop } = useLayoutContext();

  const paddingProps = isDesktop
    ? { paddingLeft: "100px", paddingRight: "40px" }
    : { paddingLeft: "2", paddingRight: "2" };

  return (
    <VStack
      {...paddingProps}
      spacing="2"
      paddingTop="4"
      paddingBottom="4"
      alignItems="start"
      color="white"
      minH="110px"
    >
      {children}
    </VStack>
  );
};

PageHeading.Title = Title;
